<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.pa--t_md.--b_md.SECTION
      +b.ug-container--variant_large
        +b.ma--b_md.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="'xl'"
          :color="'black'"
          :tag="'p'"
        ) INVOICE HISTORY
        +b.ug-row--apearance_spaced.--space_md
          +b.ug-cell.ug-cols--12.--7-lg.--8-xl.--9-mac
            +b.pa--t_1sm.--t_md-md.--r_1sm.--r_md-md.--l_1sm.--l_md-md.--b_1sm.bg--white
              +b.ug-row--apearance_spaced.--space_md
                +b.ug-cell.ug-cols--12
                  +b.ug-row--apearance_spaced.--space_md.--align_end
                    +b.ug-cell.ug-cols--12.--6-mac
                      validation-observer(
                        ref="observer"
                        tag="form"
                        class="form"
                      )
                        +b.ug-row--apearance_spaced.--space_md.--align_end
                          +b.ug-cell.ug-cols--12.--6-md
                            +b.input.D-CONTROL-INPUT(
                              v-model="formData.search"
                              :input-label="'Invoice ID'"
                              :placeholder="'Invoice ID'"
                              :name="'search'"
                              :type="'text'"
                              id="search"
                            )
                          +b.ug-cell.ug-cols--12.--6-md
                            +b.D-CONTROL-OPTION(
                              v-model="formData.status"
                              :object-list="drawOptions"
                              :input-label="'Status'"
                              :placeholder="'Status'"
                              :name="'status'"
                              id="status"
                            )
                    +b.ug-cell.ug-cols--12.--6-mac
                      +b.ug-row--apearance_spaced.--space_md
                        +b.ug-cell.ug-cols--12.--6-mac
                          +b.button--height_xl.BUTTON-BEMTO(
                            :disabled="isRequest"
                            @event="resetPaginationBeforeAPI"
                          )
                            +e.load.IMG(
                              src="/static/load.gif"
                              v-if="isRequest"
                            )
                            +e.text(
                              v-if="!isRequest"
                            ) SEARCH
                        +b.ug-cell.ug-cols--12.--6-mac
                          +b.button--height_xl.--save.BUTTON-BEMTO(
                            :disabled="isRequest"
                            @event="clearInvoiceFiltersHandler"
                          )
                            +e.load.IMG(
                              src="/static/load.gif"
                              v-if="isRequest"
                            )
                            +e.text(
                              v-if="!isRequest"
                            ) CLEAR
                +b.ug-cell.ug-cols--12
                  invoice-history-table(
                    v-if="Object.keys(drawItems).length"
                    :object-list="drawItems"
                    @ordering="setOrderingHandler"
                  )
                  +b.text.pa--b_xs-md(
                    v-if="!Object.keys(drawItems).length"
                  ) No results
          +b.ug-cell.ug-cols--12.--5-lg.--4-xl.--3-mac
            +b.withdraw--invoice
              +b.ma--b_md.TEXT-BEMTO(
                :cfg="'center'"
                :fw="'bold'"
                :lh="'initial'"
                :fs="'xl'"
                :color="'black'"
                :tag="'p'"
              ) BALANCE
              +b.ma--b_md.TEXT-BEMTO(
                :cfg="'center'"
                :fw="'bold'"
                :lh="'initial'"
                :fs="'6xl'"
                :color="'black'"
                :tag="'p'"
              ) {{ amount }} &#163
              +b.button--height_xl.ROUTER-LINK(
                :to="{ name: 'WithdrawCabinet' }"
              ) WITHDRAW
        +b.ug-cols--12
          +b.ma--t_md.PAGINATION-MODULE(
            :pagination="pagination"
            :extra="1"
            :need-add-btns="true"
            @update-limit="setPaginationLimitHandler"
            @input="pageСhangedHandler($event)"
          )
</template>

<script>
import {
  getDrawBalanceAPI,
  getDrawStatusAPI,
  getDrawHistoryAPI,
} from '@/js/services/cabinet'

import {
  asyncForEach,
} from '@/js/scripts/helpers'

export default {
  name: 'InvoiceHistoryCabinet',
  created() {
    this.getDrawBalanceAPI()
    this.getDrawStatusAPI()
    this.getDrawHistoryAPI()
  },
  data() {
    return {
      /**
       * Components state.
       */
      formData: {
        ordering: null,
        search: null,
        status: null,
      },
      drawOptions: [],
      drawItems: [],
      pagination: {},
      paginationData: {},
      amount: null,
      isRequest: false,
    }
  },
  methods: {
    getDrawBalanceAPI() {
      return getDrawBalanceAPI.execute({})
        .then(response => {
          this.amount = response.data.item.balance
        })
    },
    getDrawStatusAPI() {
      return getDrawStatusAPI.execute({})
        .then(response => {
          this.drawOptions = response.data.item
        })
    },
    getDrawHistoryAPI(OPTIONS) {
      return getDrawHistoryAPI.execute(OPTIONS)
        .then(response => response.json())
        .then(response => {
          this.drawItems = response.data.items
          this.pagination = response.data.pagination
        })
    },
    async preperedBeforeAPI() {
      /**
       * We will wait until everything is filled correctly.
       */
      const OPTIONS = {
        ...this.formData,
        ...this.paginationData,
      }
      /**
       * We will wait until everything is filled correctly.
       */
      await asyncForEach(
        Object.keys(OPTIONS), async key => {
          /**
           * The some () method checks if any element of
           * the array satisfies the condition specified
           * in the passed function.
           */
          if (!OPTIONS[key]) {
            delete OPTIONS[key]
          }
        }
      )
      await this.getDrawHistoryAPI(
        OPTIONS
      )
    },
    async clearInvoiceFiltersHandler() {
      /**
       * We will wait until everything is filled correctly.
       */
      await asyncForEach(
        Object.keys(this.formData), async key => {
          /**
           * The some () method checks if any element of
           * the array satisfies the condition specified
           * in the passed function.
           */
          this.formData[key] = null
        }
      )
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async resetPaginationBeforeAPI() {
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async pageСhangedHandler(data) {
      this.paginationData = data
      await this.preperedBeforeAPI()
    },
    async setPaginationLimitHandler(value) {
      this.paginationData.limit = value
      this.paginationData.offset = 0
      await this.preperedBeforeAPI()
    },
    async setOrderingHandler(value) {
      this.formData.ordering = value
      await this.preperedBeforeAPI()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/InvoiceHistoryCabinet.vue